import { apiClient, apiDelete, apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const salesApi = {
  listCustomers:   (params) => apiGet('/api/sales/customers', params),
  getCustomer:     (id)     => apiGet(`/api/sales/customers/${id}`),
  createCustomer:  (body)   => apiPost('/api/sales/customers', body),
  updateCustomer:  (id, body) => apiPut(`/api/sales/customers/${id}`, body),
  nextCustomerCode: ()      => apiGet('/api/sales/customers/next-code'),
  listCustomerContacts: (id) => apiGet(`/api/sales/customers/${id}/contacts`),

  listPriceLists:     ()         => apiGet('/api/sales/price-lists'),
  getPriceList:       (id)       => apiGet(`/api/sales/price-lists/${id}`),
  createPriceList:    (body)     => apiPost('/api/sales/price-lists', body),
  updatePriceList:    (id, body) => apiPut(`/api/sales/price-lists/${id}`, body),
  setPriceListActive: (id, isActive) => apiPatch(`/api/sales/price-lists/${id}/active`, { isActive }),
  deletePriceList:    (id)       => apiDelete(`/api/sales/price-lists/${id}`),
  resolvePrice:       (params)   => apiGet('/api/sales/price-lists/resolve', params),

  listCustomerAttachments:  (id)       => apiGet(`/api/sales/customers/${id}/attachments`),
  uploadCustomerAttachment: (id, body) => apiPost(`/api/sales/customers/${id}/attachments`, body),
  deleteAttachment:         (id)       => apiDelete(`/api/sales/attachments/${id}`),
  downloadAttachment: async (id, filename) => {
    const res = await apiClient.get(`/api/sales/attachments/${id}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  },

  listQuotes:      (params) => apiGet('/api/sales/quotes', params),
  getQuote:        (id)     => apiGet(`/api/sales/quotes/${id}`),
  createQuote:     (body)   => apiPost('/api/sales/quotes', body),
  updateQuote:     (id, body) => apiPut(`/api/sales/quotes/${id}`, body),
  sendQuote:       (id)     => apiPatch(`/api/sales/quotes/${id}/send`),
  acceptQuote:     (id)     => apiPatch(`/api/sales/quotes/${id}/accept`),
  rejectQuote:     (id)     => apiPatch(`/api/sales/quotes/${id}/reject`),
  convertQuote:    (id, body) => apiPost(`/api/sales/quotes/${id}/convert`, body),

  listOrders:      (params) => apiGet('/api/sales/orders', params),
  getOrder:        (id)     => apiGet(`/api/sales/orders/${id}`),
  createOrder:     (body)   => apiPost('/api/sales/orders', body),
  confirmOrder:    (id)     => apiPatch(`/api/sales/orders/${id}/confirm`),
  fulfillOrder:    (id, body) => apiPatch(`/api/sales/orders/${id}/fulfill`, body),
  cancelOrder:     (id)     => apiPatch(`/api/sales/orders/${id}/cancel`),
  creditHolds:     ()       => apiGet('/api/sales/orders/credit-holds'),
  releaseCredit:   (id)     => apiPost(`/api/sales/orders/${id}/credit-release`, {}),
  rejectCredit:    (id)     => apiPost(`/api/sales/orders/${id}/credit-reject`, {}),
  customerCredit:  (id)     => apiGet(`/api/sales/customers/${id}/credit`),

  listReturns:     (params) => apiGet('/api/sales/returns', params),
  getReturn:       (id)     => apiGet(`/api/sales/returns/${id}`),
  createReturn:    (body)   => apiPost('/api/sales/returns', body),
  approveReturn:   (id)     => apiPatch(`/api/sales/returns/${id}/approve`),
  rejectReturn:    (id, note) => apiPatch(`/api/sales/returns/${id}/reject`, note ? { note } : {}),
  receiveReturn:   (id)     => apiPatch(`/api/sales/returns/${id}/receive`),

  listContracts:   (params) => apiGet('/api/sales/contracts', params),
  createContract:  (body)   => apiPost('/api/sales/contracts', body),
  cancelContract:  (id)     => apiPatch(`/api/sales/contracts/${id}/cancel`),

  listTickets:     (params) => apiGet('/api/sales/tickets', params),
  getTicket:       (id)     => apiGet(`/api/sales/tickets/${id}`),
  createTicket:    (body)   => apiPost('/api/sales/tickets', body),
  setTicketStatus: (id, status) => apiPatch(`/api/sales/tickets/${id}/status`, { status }),
  assignTicket:    (id, assigneeId) => apiPatch(`/api/sales/tickets/${id}/assign`, { assigneeId }),
  addTicketComment: (id, body) => apiPost(`/api/sales/tickets/${id}/comments`, { body }),

  listDeliveries:      (params) => apiGet('/api/sales/deliveries', params),
  getDelivery:         (id)     => apiGet(`/api/sales/deliveries/${id}`),
  listOrderDeliveries: (id)     => apiGet(`/api/sales/orders/${id}/deliveries`),

  listOpportunities: (params) => apiGet('/api/sales/opportunities', params),
  createOpportunity: (body)   => apiPost('/api/sales/opportunities', body),
  transitionOpportunity: (id, body) => apiPatch(`/api/sales/opportunities/${id}/stage`, body),

  funnel:          (params) => apiGet('/api/sales/pipeline/funnel', params),
  salesByCustomer: (params) => apiGet('/api/sales/reports/sales-by-customer', params),
  salesByProduct:  (params) => apiGet('/api/sales/reports/sales-by-product', params),

  // Analytics (charts)
  timeseries:      (params) => apiGet('/api/sales/reports/timeseries', params),
  orderStatus:     ()       => apiGet('/api/sales/reports/order-status'),
  pipelineStages:  ()       => apiGet('/api/sales/reports/pipeline-stages'),
  topCustomers:    (params) => apiGet('/api/sales/reports/top-customers', params),

  // Insight strips (list-page summaries)
  quoteInsights:    () => apiGet('/api/sales/reports/quote-insights'),
  orderInsights:    () => apiGet('/api/sales/reports/order-insights'),
  customerInsights: () => apiGet('/api/sales/reports/customer-insights'),
};
